module.exports = "/_next/static/media/b4de758fb6e53d75f7f8b64885e816f5.svg";